import css from "./footer.module.scss";

interface EngagementFooterProps {
  numberOfRoles?: number;
}

export const EngagementFooter = ({ numberOfRoles }: EngagementFooterProps) => (
  <div className={css.wrapper}>
    {!!numberOfRoles && numberOfRoles > 0 && (
      <div className={css.engagement}>
        <b>{numberOfRoles}</b>
        {numberOfRoles === 1 ? " Role" : " Roles"}
      </div>
    )}
  </div>
);
